module.exports = __webpack_public_path__ + "img/qrcode.d73ed15f.jpg";